import React, { ReactElement } from 'react';
import { Formik, FormikProps, FormikValues } from 'formik';
import {
  filterFormData,
  getFormDataFromCaseData,
  WorkflowComponentProps,
} from '../../../../WorkflowContainer/workflow-utils';
import { WorkFlowFooter } from '../../../../../components/workflowFooter/WorkFlowFooter';
import AppealHearingLogisticsForm from './AppealHearingLogisticsForm';
import { appeal_hearing_hearingLogisticsSchema } from '../../../../../forms/ValidationSchema/AppealHearingValidationSchema';

const AppealHearingLogistics: React.FC<WorkflowComponentProps> = (props: WorkflowComponentProps) => {
  const { caseData, flowableFunctions } = props.data;
  const fields = {
    appeal_hearing_hearingDate: 'string',
    appeal_hearing_hearingTime: 'string',
    appeal_hearing_hearingLocation: 'string',
    appeal_hearing_chairpersonFirstName: 'string',
    appeal_hearing_chairpersonLastName: 'string',
    appeal_hearing_chairpersonEmailAddress: 'string',
    appeal_hearing_employerRepresentativeFirstName: 'string',
    appeal_hearing_employerRepresentativeLastName: 'string',
    appeal_hearing_employerRepresentativeEmailAddress: 'string',
    appeal_hearing_hearingWitnesses: 'array',
  };

  const initialValues: FormikValues = getFormDataFromCaseData(fields, caseData);
  const submitValues = async (values: FormikValues): Promise<void> => {
    await flowableFunctions.onNext(getFormValuesForSubmission(values));
  };

  const getFormValuesForSubmission = (values: FormikValues): Record<string, any> => {
    const formValues = { ...values };
    formValues.appeal_hearing_hearingWitnesses = JSON.stringify(formValues.appeal_hearing_hearingWitnesses);
    return filterFormData(formValues, fields);
  };

  console.log('cash', caseData);

  return (
    <div className="content">
      <Formik
        initialValues={initialValues}
        validationSchema={appeal_hearing_hearingLogisticsSchema}
        enableReinitialize
        onSubmit={submitValues}
      >
        {({ values, handleSubmit }: FormikProps<FormikValues>): ReactElement => (
          <>
            <AppealHearingLogisticsForm data={props.data} getFormValuesForSubmission={getFormValuesForSubmission} />
            <WorkFlowFooter
              data={props.data}
              onNext={handleSubmit}
              onCancel={(): void => console.log('cancel')}
              onSaveAndClose={(): void => {
                props.data.flowableFunctions.onSaveAndClose(values);
              }}
            />
          </>
        )}
      </Formik>
    </div>
  );
};

export default AppealHearingLogistics;
